import api from "./axios";

export const bulkImportAPI = (module, formData) => {
  return api.post(`/bulk-import/${module}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
